var map = {
	"./E@2x.png": 164,
	"./ENE@2x.png": 165,
	"./ESE@2x.png": 166,
	"./N@2x.png": 167,
	"./NE@2x.png": 168,
	"./NNE@2x.png": 169,
	"./NNW@2x.png": 170,
	"./NW@2x.png": 171,
	"./S@2x.png": 172,
	"./SE@2x.png": 173,
	"./SSE@2x.png": 174,
	"./SSW@2x.png": 175,
	"./SW@2x.png": 176,
	"./W@2x.png": 177,
	"./WNW@2x.png": 178,
	"./WSW@2x.png": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;